import { ArrowUp, ArrowDown } from "lucide-react";

export function Loading({ label = "Loading" }) {
  return (
    <div className="flex h-[60vh] flex-col items-center justify-center gap-4" data-testid="app-loading">
      <div className="relative h-14 w-14">
        <div className="absolute inset-0 rounded-full" style={{ background: "conic-gradient(from 0deg, #1a5fd0, #5a8bff, #d8b25a, #1a5fd0)", WebkitMask: "radial-gradient(farthest-side, transparent calc(100% - 4px), #000 0)", mask: "radial-gradient(farthest-side, transparent calc(100% - 4px), #000 0)", animation: "spin 1.1s linear infinite" }} />
        <div className="absolute inset-0 flex items-center justify-center"><span className="h-2 w-2 rounded-full bg-[#d8b25a]" style={{ animation: "pulse 1.4s ease-in-out infinite" }} /></div>
      </div>
      <div className="font-mono text-[10px] font-bold uppercase tracking-[0.3em] text-slate-400">{label}</div>
    </div>
  );
}

export function DeltaPill({ value, className = "" }) {
  const up = String(value).trim().startsWith("+") || (typeof value === "number" && value > 0);
  const flat = String(value).trim() === "0";
  return (
    <span className={`inline-flex items-center gap-0.5 rounded-md px-1.5 py-0.5 font-mono text-[11px] font-semibold ${
      flat ? "bg-slate-100 text-slate-500" : up ? "bg-emerald-50 text-emerald-600" : "bg-red-50 text-red-600"
    } ${className}`}>
      {!flat && (up ? <ArrowUp size={11} /> : <ArrowDown size={11} />)}
      {value}
    </span>
  );
}

export function Stat({ label, value, sub, tone = "slate" }) {
  const colors = { slate: "text-slate-900", blue: "text-[#1a5fd0]", green: "text-emerald-600", red: "text-red-600" };
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4">
      <div className="font-mono text-[10px] uppercase tracking-wider text-slate-400">{label}</div>
      <div className={`mt-1 font-head text-2xl font-extrabold tabular-nums ${colors[tone]}`}>{value}</div>
      {sub && <div className="mt-0.5 text-[11px] text-slate-400">{sub}</div>}
    </div>
  );
}

export function Bar({ pct, tone = "#1a5fd0", track = "#e2e8f0", height = 7 }) {
  return (
    <div className="w-full overflow-hidden rounded-full" style={{ background: track, height }}>
      <div className="h-full rounded-full transition-all duration-700" style={{ width: `${Math.min(100, Math.max(0, pct))}%`, background: tone }} />
    </div>
  );
}
